import { useIntl } from 'react-intl';
import classNames from 'classnames';
import { IClientMessage } from '../../interfaces';
import React from 'react';
import { useMessageContext } from '../message/message.context';
import { messageMessages } from '../message/message.i18n';
import { useBlockMessageClassNames } from 'src/hooks/core/messages.hooks';
import { Message } from '../UI/Message/Message';
import type { IOptionalMessageProps } from '../UI/Message/Message';

export const InvalidMessage = React.forwardRef<
	HTMLElement,
	{ className?: string } & IOptionalMessageProps
>(function InvalidMessage({ className: classNameProp, ...props }, ref) {
	const intl = useIntl();
	const message__invalid_message = intl.formatMessage(
		messageMessages.message__invalid_message,
	);

	const { message } = useMessageContext<IClientMessage>();
	const messageClassName = useBlockMessageClassNames();

	return (
		<Message
			{...props}
			ref={ref}
			message={message}
			className={classNames(
				classNameProp,
				messageClassName,
				'message--invalid',
			)}
		>
			<small>
				<i>{message__invalid_message}</i>
			</small>
		</Message>
	);
});
